import React, { useEffect, useState } from "react";
import Icon from "../Icon";
import { Frame, Img, Placeholder } from "./styles";

interface PhotoProps {
  src?: string;
  label?: string;
  radius?: number;
  objectPosition?: string;
  style?: React.CSSProperties;
}

export default function Photo({
  src,
  label = "foto",
  radius = 16,
  objectPosition = "center",
  style,
}: PhotoProps) {
  const [err, setErr] = useState(false);
  useEffect(() => {
    setErr(false);
  }, [src]);
  if (!src || err) {
    return (
      <Placeholder data-testid="photo-placeholder" $radius={radius} style={style}>
        <Icon name="image" size={22} color="#AEBDB8" strokeWidth={1.7} />
        <span>{label}</span>
      </Placeholder>
    );
  }
  return (
    <Frame $radius={radius} style={style}>
      <Img src={src} alt={label} loading="lazy" style={{ objectPosition }} onError={() => setErr(true)} />
    </Frame>
  );
}
